/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var StringUtils = /** @class */function () {
  function StringUtils() {}
  /**
   * Check if a string is empty
   *
   * @param str
   */
  StringUtils.isEmpty = function (str) {
    return typeof str === "undefined" || !str || 0 === str.length;
  };
  return StringUtils;
}();
export { StringUtils };